module.exports = __webpack_public_path__ + "static/media/gdpr-all-about-cover-en@2x.c6aecae3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ebook/gdpr-all-about-cover-en@2x.jpg
// module id = 553
// module chunks = 0